import { useEffect, useMemo, useState } from "react";

/**
 * 選択した年・月に応じて動的に日付リストを生成するカスタムフック
 */

const lastDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const leapYearLastDay = 29;

export const useDateSelector = (year?: number, month?: number) => {
  const [dateOptions, setDateOptions] = useState<{ label: string; value: number }[]>([]);

  const monthOptions = useMemo(
    () => Array.from({ length: 12 }, (_, i) => ({ label: `${i + 1}月`, value: i + 1 })),
    [],
  );

  useEffect(() => {
    if (!year || !month) {
      setDateOptions([]);
      return;
    }

    const lastDate = getLastDate(year, month);
    const newDates = Array.from({ length: lastDate }, (_, i) => ({
      label: `${i + 1}日`,
      value: i + 1,
    }));

    setDateOptions(newDates);
  }, [year, month]);

  return {
    monthOptions,
    dateOptions,
  };
};

/** 年と月からその月の最終日を求める */
const getLastDate = (year: number, month: number): number => {
  if (month === 2 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) {
    return leapYearLastDay;
  }
  return lastDays[month - 1];
};
